module.exports = __webpack_public_path__ + "assets/img/officialAccount.f9c2b71c.svg";